import React from 'react';
import { useParams } from 'react-router-dom';
import { useEffect, useState,useCallback } from 'react';
import { axios } from '../../../../../../utils/axios';
import { showAlert } from '../../../../../../utils/alerts';

import SellingTable from './table';

const SellingCountry = ({ activeCountrySubTab, activeSubTab, setLogsModal, skus,refreshSkus,sellingCountry }) => {

  const [data, setData] = useState([]);
  const { crNumber } = useParams();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (activeCountrySubTab === 'sellingCountry' && activeSubTab === 'tpErpSetup') {
      setData(skus)
    }
  }, [activeCountrySubTab, activeSubTab,skus]);

  const handleRefresh = async (rowData) => {
    try {

      setLoading(true);
      const payload = {   //here only costing_request_id and condition_record_id required
        costing_request_id: crNumber,
        distribution_channel: rowData.distribution_channel,
        condition_type: rowData.condition_type,
        condition_record_id: rowData.condition_record_id,
        flag: 'Retry',
      };
      if(payload.condition_type === 'MR21' || payload.condition_type === 'PIR' )
        return;
     
      const response = await axios.post(`/costing-request/tp-erp-retry/${crNumber}`, payload);

      if (response.status === 200 && response.data.success === true) {

        showAlert(
          {
            message: `TP Setup successfully refreshed for Sales Org ${rowData.sales_org}`,
          },
          'success',
        );

        setData((prevData) =>
          prevData.map((sku) =>
            sku.id === rowData.id
              ? {
                ...sku,
                status: 'Closed',
                retryEnabled: false, // Disable retry
                // valid_from: validFrom,
                // valid_to: validTo,
              }
              : sku,
          ),
        );
        if (refreshSkus) await refreshSkus();
      } else {
        throw new Error(response.data.message || 'Refresh failed. Please check the logs.');
      }
    } catch (error) {
      showAlert(
        {
          message: `TP Setup refresh failed for Sales Org ${rowData.sales_org}. Please check logs.`,
        },
        'error',
      );
      // Re-enable retry button for the failed row
      setData((prevData) =>
        prevData.map((sku) =>
          sku.id === rowData.id
            ? {
              ...sku,
              retryEnabled: true, // Enable retry
              isSaved: false,
            }
            : sku,
        ),
      );
      console.error('Error during refresh:', error);
    } finally {
      setLoading(false);
    }
   };

   const fetchLogs = useCallback(async (rowId) => {
    try {
      const response = await axios.get(`/costing-request/tp-erp-setup-logs/${crNumber}`, {
        params: { rowId }, 
      });
      if (response.status !== 200) throw new Error('Failed to fetch logs');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching logs:', error);
      throw error;
    }
  }, [crNumber]);
  

  return (
    <>
      <SellingTable
        handleRefresh={handleRefresh}
        data={data}
        sellingCountry={sellingCountry}
        loading={loading}
        setLogsModal={setLogsModal}
        fetchLogs={fetchLogs}

      />
    </>
  )
}

export default SellingCountry